import * as React from "react";
import "./style.less";

import Location from "one-ui-svg/images/location.png";
import Label from "one-ui-svg/images/label.png";
import Phone from "one-ui-svg/images/phone.png";

import { CardLockIcon } from 'one-card-notification';

import { Image_URL } from 'one-ui-image';

import { CardNoData } from 'one-ui-card';

import { CallingDestModel } from "./model";
import { CallDestinationCardProps } from "./props";
import { useCtx } from "one-ui-provider";

export const CallDestinationCard = <M extends CallingDestModel>(
    props: CallDestinationCardProps<M>
) => {
    const { model, title } = props;
    const { callingdest } = model || {};

    const { settings, resolver, static_resource_url } = useCtx();
    const { uisettings } = settings;
    const { calling_dest_card } = uisettings;
    const {
        card_display,
        entitytype_display,
        name_display,
        phone_display,
        address_display,
    } = calling_dest_card;
    let monToFriHours = true;
    let daysdata: any;
    let monTime = "";
    let tueTime = '';
    let wedTime = '';
    let thuTime = '';
    let friTime = '';
    let satTime = "";
    let sunTime = "";

    if (callingdest?.calldest) {
        if (callingdest.calldest.hoursoperation) {
            daysdata = callingdest.calldest.hoursoperation;
            if (
                daysdata.monday_start === daysdata.tuesday_start &&
                daysdata.monday_start === daysdata.wednesday_start &&
                daysdata.monday_start === daysdata.thursday_start &&
                daysdata.monday_start === daysdata.friday_start
            ) {
                monTime = `${daysdata.monday_start ? daysdata.monday_start : ""} - ${daysdata.monday_end ? daysdata.monday_end : ""}`;
                satTime = `${daysdata.saturday_start ? daysdata.saturday_start : ""}  - ${daysdata.saturday_end ? daysdata.saturday_end : ""}`;
                sunTime = `${daysdata.sunday_start ? daysdata.sunday_start : ""} - ${daysdata.sunday_end ? daysdata.sunday_end : ""}`;
            } else {
                monToFriHours = false;
                monTime = `${daysdata.monday_start ? daysdata.monday_start : ""} - ${daysdata.monday_end ? daysdata.monday_end : ""}`;
                tueTime = `${daysdata.tuesday_start ? daysdata.tuesday_start : ""} - ${daysdata.tuesday_end ? daysdata.tuesday_end : ""}`;
                wedTime = `${daysdata.wednesday_start ? daysdata.wednesday_start : ""} - ${daysdata.wednesday_end ? daysdata.wednesday_end : ""}`;
                thuTime = `${daysdata.thursday_start ? daysdata.thursday_start : ""} - ${daysdata.thursday_end ? daysdata.thursday_end : ""}`;
                friTime = `${daysdata.friday_start ? daysdata.friday_start : ""} - ${daysdata.friday_end ? daysdata.friday_end : ""}`;
                satTime = `${daysdata.saturday_start ? daysdata.saturday_start : ""}  - ${daysdata.saturday_end ? daysdata.saturday_end : ""}`;
                sunTime = `${daysdata.sunday_start ? daysdata.sunday_start : ""} - ${daysdata.sunday_end ? daysdata.sunday_end : ""}`;
            }
        }
    }

    let workHours = !monToFriHours ? (
        <div>
            <div>
                <strong>Mon:</strong>
                {monTime}
            </div>
            <div>
                <strong>Tue:</strong>
                {tueTime}
            </div>
            <div>
                <strong>Wed:</strong>
                {wedTime}
            </div>
            <div>
                <strong>Thu:</strong>
                {thuTime}
            </div>
            <div>
                <strong>Fri:</strong>
                {friTime}
            </div>
            <div>
                <strong>Sat:</strong>
                {satTime}
            </div>
            <div>
                <strong>Sun:</strong>
                {sunTime}
            </div>
        </div>
    ) : (
        <div>
             <div>
                <strong>Mon-Fri:</strong>
                {monTime}
            </div>
            <div>
                <strong>Sat:</strong>
                {satTime}
            </div>
            <div>
                <strong>Sun:</strong>
                {sunTime}
            </div>
        </div>
    );

    let result;

    if (!card_display) {
        result = (
            <div className="call-destination">
                <div className="call-destination-header">
                    <p className="title">{title}</p>
                </div>
                <div className="call-destination-content">
                    <CardLockIcon />
                </div>
            </div>
        )
    } else if (!callingdest?.calldest) {
        result = (
            <div className="call-destination">
                <div className="call-destination-header">
                    <p className="title">{title}</p>
                </div>
                <div className="call-destination-content">
                    <CardNoData />
                </div>
            </div>
        );
    } else {
        result = (
            <div className='call-destination'>
                <div className="call-destination-header">
                    <p className="title">{title}</p>
                </div>
                <div className="call-destination-content">
                    <div className="call-destination-container">
                        <div>
                            {name_display && (
                                <p className="destination">{callingdest?.calldest?.calledname}</p>
                            )}
                        </div>
                        <div>
                            <p className="close">{callingdest?.calldest?.note}</p>
                        </div>
                    </div>
                    <div className="call-destination-container">
                        <div className='call-destination-container--destination'>
                            <div>
                                {phone_display && (
                                    <div>
                                        <img src={Image_URL(resolver(Phone), `${static_resource_url}phone.13f0d713.png`)} />
                                        <span style={{marginRight: '5px'}}>{callingdest?.calldest?.calledphone}</span>
                                    </div>
                                )}
                            </div>
                            <div>
                                {address_display && (
                                    <div>
                                        <img src={Image_URL(resolver(Location), `${static_resource_url}location.8a1a3b37.png`)} />
                                        <span style={{marginRight: '5px'}}>{callingdest?.calldest?.calledaddress}</span>
                                    </div>
                                )}
                            </div>
                            <div>
                                {entitytype_display && (
                                    <div>
                                        <img src={Image_URL(resolver(Label), `${static_resource_url}label.e151bdbb.png`)} />
                                        <span style={{marginRight: '5px'}}>{callingdest?.calldest?.calledtype}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='call-destination-container--work-hours'>
                            {workHours}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    if (callingdest?.calldest?.calledphone.length<=0 && callingdest?.calldest?.calledaddress.length<=0 && callingdest?.calldest?.calledname.length<=0 && Object.keys( callingdest?.calldest?.hoursoperation).length<=0) {
        result = (
            <div className="call-destination">
                <div className="call-destination-header">
                    <p className="title">{title}</p>
                </div>
                <div className="call-destination-content">
                <CardNoData />
                </div>
            </div>
        )
    }

    return result;
};
